module.exports = __webpack_public_path__ + "static/media/08_before.0213aef8.jpg";